import type { FunctionComponent } from 'react';

import { Analytics } from '@trello/atlassian-analytics';
import { RouterLink } from '@trello/router/router-link';

import type { TemplateCategoryImagePath } from './getTemplateCategoryImage';
import { getTemplateCategoryImage } from './getTemplateCategoryImage';

import styles from './TemplatesGalleryCategoryTile.less';

interface TemplatesGalleryCategoryTileProps {
  categoryKey: string;
  title: string;
  url: string;
}

export const TemplatesGalleryCategoryTile: FunctionComponent<
  TemplatesGalleryCategoryTileProps
> = ({ categoryKey, title, url }) => {
  const onClick = () => {
    Analytics.sendClickedLinkEvent({
      linkName: 'templateFeaturedCategoryLink',
      source: 'templateGalleryScreen',
      attributes: {
        category: categoryKey,
      },
    });
  };

  return (
    <div className={styles.tileLinkContainer}>
      <RouterLink
        className={styles.tileLink}
        href={url}
        title={title}
        onClick={onClick}
      >
        <div className={styles.tileImageContainer}>
          <img
            className={styles.tileImage}
            src={getTemplateCategoryImage(
              categoryKey as TemplateCategoryImagePath,
            )}
            alt={`${title} Icon`}
          />
        </div>
        <span className={styles.tileTitle}>{title}</span>
      </RouterLink>
    </div>
  );
};
